import { render, staticRenderFns } from "./InvestmentsModal.vue?vue&type=template&id=01470105"
import script from "./InvestmentsModal.vue?vue&type=script&lang=js"
export * from "./InvestmentsModal.vue?vue&type=script&lang=js"
import style0 from "./InvestmentsModal.vue?vue&type=style&index=0&id=01470105&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports